import { useEffect, useState } from 'react';
import { postService } from '../../services/post.service';
import toast from 'react-hot-toast';

export const useReactPost = ({
  postId,
  type,
}: {
  postId: string;
  type?: number;
}) => {
  const [liked, setLiked] = useState<boolean>(false);
  const [disliked, setDisLied] = useState<boolean>(false);
  const [interactedUsers, setInteractedUsers] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const handleLikePost = async () => {
    try {
      await postService.likePost(postId);
      setLiked(true);
      toast.success('Bạn đã thích bài viết này thành công');
    } catch (error) {
      //
    }
  };

  const handleDisLikePost = async () => {
    try {
      await postService.diLikePost(postId);
      setDisLied(true);
      toast.success('Bạn đã không thích bài viết này thành công');
    } catch (error) {
      //
    }
  };

  const handleShowConfirm = async (suppressDays) => {
    try {
      await postService.confirmShow(true, suppressDays);
      window.location.reload();
    } catch (error) {
      //
    }
  };

  const listAction = async (page = 1) => {
    try {
      const response = await postService.listAction(postId, type, page);
      if (page === 1) {
        setInteractedUsers(response.data);
      } else {
        setInteractedUsers((prev) => [...prev, ...response.data]);
      }
      setHasMore(response.hasMore);
      setPageNumber(page);
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    listAction();
  }, [postId, type]);

  return {
    liked,
    disliked,
    handleLikePost,
    handleDisLikePost,
    handleShowConfirm,
    listAction,
    interactedUsers,
    hasMore,
  };
};
